import Page from '@/components/content/Page'
import { Translation } from '@/components/i18n/Translation'

import { InjuryReportsContextProvider } from './index.context'
import InjuryReportList from './InjuryReportList'
import InjuryReportListFilters from './InjuryReportListFilters'

const InjuryReportsPage = () => (
  <InjuryReportsContextProvider>
    <Page>
      <h1>
        <Translation id="Injury Reports" />
      </h1>

      <InjuryReportListFilters />

      <InjuryReportList />
    </Page>
  </InjuryReportsContextProvider>
)

export default InjuryReportsPage
